@if(src) {
    <iframe class="iframe--paybee" width="375px" height="100%" [src]="src | safe"></iframe>
}